import { useQuery } from '@tanstack/react-query';
import { OperationLog } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';

export const OPERATIONS_QUERY = [
  '@MDH',
  'getOperationsApiV2OperationGet',
] as const;

export const isOperationInProgress = (operation: OperationLog | undefined) =>
  operation?.status === 'IN_PROGRESS' || operation?.status === 'WAITING';

export const useOperations = ({
  datasetName,
  enabled,
  limit,
}: {
  datasetName?: string | undefined;
  enabled?: boolean | undefined;
  limit?: number;
}) => {
  return useQuery({
    queryKey: [...OPERATIONS_QUERY, datasetName, limit],
    refetchInterval: 3000,
    keepPreviousData: true,
    enabled,
    queryFn: () =>
      datasetApi.getOperationsApiV2OperationGet(
        { dataset_name: datasetName, limit },
        getDatasetRequestConfig()
      ),
    select: res => res.data.operations,
  });
};
